import { render, staticRenderFns } from "./detail-item.vue?vue&type=template&id=ed81079e&scoped=true"
import script from "./detail-item.vue?vue&type=script&lang=ts"
export * from "./detail-item.vue?vue&type=script&lang=ts"
import style0 from "./detail-item.vue?vue&type=style&index=0&id=ed81079e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed81079e",
  null
  
)

export default component.exports